// extracted by mini-css-extract-plugin
module.exports = {"Create":"Create_Create__vYkOE"};